/* claude-clemes-autumn.js — theme 4.16
   Behaviour for the curated autumn hero.

   The track is a native scroll-snap strip, which is deliberate and carried
   over from 3.89 / 4.15: a swipe moves the strip and cannot fire the link's
   click, so tap-to-open and swipe-to-browse stop fighting each other without
   any touch-event bookkeeping.

   Tabs jump to the first slide of their group and light up as the strip moves.
   Autoplay stops permanently the moment the visitor does anything, and never
   starts under prefers-reduced-motion.

   No backslashes anywhere in this file, on purpose — uploading theme files
   through the GraphQL variable channel has silently doubled them before. */

(function () {
  function init(root) {
    if (root.dataset.cahReady === '1') return;
    root.dataset.cahReady = '1';

    var track = root.querySelector('[data-cah-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cah-slide]'));
    if (!slides.length) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-cah-tab]'));
    var fill = root.querySelector('[data-cah-fill]');
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-cah-arrow]'));

    var speed = parseInt(root.dataset.speed, 10);
    if (isNaN(speed)) speed = 0;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var stopped = false;
    var current = 0;

    function index() {
      var w = track.clientWidth;
      if (!w) return 0;
      var i = Math.round(track.scrollLeft / w);
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      return i;
    }

    function paint() {
      current = index();
      if (fill) fill.style.width = ((current + 1) / slides.length) * 100 + '%';
      var group = slides[current].getAttribute('data-group');
      tabs.forEach(function (t) {
        t.setAttribute('aria-current', t.getAttribute('data-group') === group ? 'true' : 'false');
      });
      if (slides.length < 2) {
        arrows.forEach(function (a) { a.style.display = 'none'; });
      }
    }

    function goTo(i, smooth) {
      if (i < 0) i = slides.length - 1;
      if (i > slides.length - 1) i = 0;
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth === false ? 'auto' : 'smooth' });
    }

    function stop() {
      stopped = true;
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (stopped || reduced || speed <= 0 || slides.length < 2) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () {
        if (document.hidden) return;
        goTo(index() + 1);
      }, speed * 1000);
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var g = t.getAttribute('data-group');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-group') === g) { goTo(i); break; }
        }
        stop();
      });
    });

    arrows.forEach(function (a) {
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        goTo(index() + parseInt(a.getAttribute('data-cah-arrow'), 10));
        stop();
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { paint(); ticking = false; });
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      track.addEventListener(ev, stop, { passive: true });
    });

    root.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowRight') { goTo(index() + 1); stop(); }
      if (ev.key === 'ArrowLeft') { goTo(index() - 1); stop(); }
    });

    window.addEventListener('resize', function () { goTo(current, false); }, { passive: true });

    paint();
    start();
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-cah]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
